import React from 'react';

import {
  ArticleCallout,
  ArticleChecklist,
  ArticleEyebrow,
  ArticleHero,
  ArticleList,
  ArticleMediaFrame,
  ArticleSection,
  ArticleShell,
  ArticleTag,
  ArticleTagRow,
} from '../../articleStyles';
import { useHelpCenterLocale } from '../../localization';
import { HelpCenterContentDefinition } from '../../types';
import translations from './translations';

export const DATABASE_MANAGEMENT_FILE_GUIDE_SLUG = 'database-management-file-guide';

const Content: React.FC<{ mode: 'page' | 'modal' }> = ({ mode }) => {
  const t = useHelpCenterLocale(translations);

  return (
    <ArticleShell mode={mode}>
      <ArticleHero compact={mode === 'modal'}>
        <ArticleEyebrow>{t.category}</ArticleEyebrow>
        <h1>{t.title}</h1>
        <p>{t.hero}</p>
        <ArticleTagRow>
          {t.tags.map((tag) => (
            <ArticleTag key={tag}>{tag}</ArticleTag>
          ))}
        </ArticleTagRow>
      </ArticleHero>

      <ArticleSection>
        <h3>{t.beforeUploadTitle}</h3>
        <ArticleChecklist>
          <li>{t.beforeUploadItem1}</li>
          <li>{t.beforeUploadItem2}</li>
          <li>{t.beforeUploadItem3}</li>
        </ArticleChecklist>
      </ArticleSection>

      <ArticleSection>
        <h3>{t.structureTitle}</h3>
        <ArticleList>
          <li>{t.structureItem1}</li>
          <li>{t.structureItem2}</li>
          <li>{t.structureItem3}</li>
        </ArticleList>
      </ArticleSection>

      <ArticleSection>
        <h3>{t.flowTitle}</h3>
        <ArticleList>
          <li>{t.flowStep1}</li>
          <li>{t.flowStep2}</li>
          <li>{t.flowStep3}</li>
          <li>{t.flowStep4}</li>
        </ArticleList>
      </ArticleSection>

      <ArticleCallout tone="warning">
        <strong>{t.warningLabel}: </strong>
        {t.warningText}
      </ArticleCallout>

      <ArticleMediaFrame>
        <h4>{t.mediaTitle}</h4>
        <p>{t.mediaDescription}</p>
      </ArticleMediaFrame>
    </ArticleShell>
  );
};

const databaseManagementFileGuide: HelpCenterContentDefinition = {
  id: 'database-management-file-guide',
  slug: DATABASE_MANAGEMENT_FILE_GUIDE_SLUG,
  meta: translations,
  keywords: {
    en: ['csv', 'upload', 'file', 'spreadsheet', 'template', 'import'],
    pt: ['csv', 'upload', 'arquivo', 'planilha', 'modelo', 'importação'],
  },
  order: 1,
  visibility: { type: 'public' },
  allowedDisplayModes: ['page', 'modal'],
  Content,
};

export default databaseManagementFileGuide;
